import { render, staticRenderFns } from "./ProjectReprintHeaderFooterText.vue?vue&type=template&id=2ee64f52&scoped=true&lang=pug&"
import script from "./ProjectReprintHeaderFooterText.vue?vue&type=script&lang=ts&"
export * from "./ProjectReprintHeaderFooterText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee64f52",
  null
  
)

export default component.exports